// @flow
import React, { useState, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import RowLayout, { RowLayoutContent, HeaderContent, Header } from 'app/common/layouts/RowLayout';

import StatementEditForm, { type FormData } from './StatementEditForm';
import { StatementsContext } from './StatementsData';
import { transform2Api } from './transformData';
import styles from './StatementNew.scss';


type Props = {
  onCancel: () => void,
}

const StatementNew = ({ onCancel }: Props) => {
  const { t } = useTranslation('statements');
  const [saving, setSaving] = useState(false);

  const [, { handleSubmitStatement }] = useContext(StatementsContext);

  const handleSubmit = useCallback(async (formData: FormData) => {
    setSaving(true);
    const res = await handleSubmitStatement(transform2Api(formData));
    setSaving(false);
    if (res) {
      onCancel();
    }
  }, [onCancel, handleSubmitStatement]);


  return (
    <RowLayout className={styles.root} paddingfree>
      <HeaderContent>
        <Header>{t('add_statement_header')}</Header>
      </HeaderContent>
      <RowLayoutContent>
        <StatementEditForm
          onSubmit={handleSubmit}
          onCancel={onCancel}
          saving={saving}
        />
      </RowLayoutContent>
    </RowLayout>
  );
};

export default StatementNew;
